// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__3euZY","link-external":"Link_link-external__2b8Zv"};